// todo 18 hrs - winter time, 17 hrs summer time (not sure how to fix it)
const firstMeetingUtc = new Date(Date.UTC(2022, 10 /*monthIndex: 0==Jan, 11==Dec*/, 24, 18, 0));

const meetingPeriodMs = 7 * 24 * 60 * 60 * 1000;
const meetingDurationMs = 1 * 60 * 60 * 1000;
const showLinkBeforeMs = 30 * 60 * 1000;

const months = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'];
const days = ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'];

let upcomingMeeting = {
	dateUtc: firstMeetingUtc,
	topic: 'Ежедневные размышления',
};

while (utcNow().getTime() - meetingDurationMs > upcomingMeeting.dateUtc.getTime()) {
	upcomingMeeting.dateUtc = new Date(upcomingMeeting.dateUtc.getTime() + meetingPeriodMs);
}

upcomingMeeting.when = `${days[upcomingMeeting.dateUtc.getDay()]},<br> ${upcomingMeeting.dateUtc.getDate()} ${months[upcomingMeeting.dateUtc.getMonth()]}`;

//console.log('upcoming', upcomingMeeting, upcomingMeeting.dateUtc.getDay(), upcomingMeeting.dateUtc.getMonth());

function isMeetingNow() {
	const now = utcNow();
	return (
		(upcomingMeeting.dateUtc > now && upcomingMeeting.dateUtc < now.getTime() + showLinkBeforeMs) ||
		(upcomingMeeting.dateUtc < now && upcomingMeeting.dateUtc.getTime() + meetingDurationMs > now)
	);
}

function utcNow() {
	return new Date(Date.now());
}

export default {
	upcomingMeeting,
	isMeetingNow,
};
